// extracted by mini-css-extract-plugin
export var downArrow = "_9x-0";
export var infoTooltipIcon = "_9x-3";
export var label = "_9x-1";
export var optionCard = "_9x-4";
export var upArrow = "_9x-2";